<template>
  <div class="expandedToolbar">
    <div class="expandedToolbarContent">
      <div class="row" style="padding: 0px 15px">
        <div class="col" v-if="newButton" cols="6" sm="3">
          <q-btn
            @click="$emit('newButtonClick')"
            class="iconButton"
            color="white"
            outlined
          >
            <q-icon style="color: white">mdi-plus</q-icon>New
          </q-btn>
        </div>
        <div class="col" v-if="changeDateRange" cols="6" sm="3">
          <q-btn
            class="iconButton"
            color="white"
            outlined
            @click="$emit('changeDateRangeClick')"
            >Change Date Range</q-btn
          >
          <p v-if="dateRangeFilter" class="btnSubHeader">
            {{ dateRangeFilter.dateRange[0] }} ~
            {{ dateRangeFilter.dateRange[1] }}
          </p>
        </div>
        <div class="col" v-if="getExtendedData" cols="6" sm="3">
          <q-btn
            class="iconButton"
            color="white"
            outlined
            @click="$emit('getExtendedDataClick')"
            >Get Extended Data</q-btn
          >
          <p class="btnSubHeader">Get selected row Extended Data</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: ["newButton", "changeDateRange", "getExtendedData", "dateRangeFilter"],
    data: () => ({}),
    beforeCreate() {},
    mounted() {},
    methods: {},
  };
</script>

<style scoped>
  .expandedToolbar {
    background: #f58122;
    position: relative;
    width: 100%;
    min-height: 64px;
    box-shadow: 0px 6px 4px 0px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
  }
  .expandedToolbar .btnSubHeader {
    color: white;
    font-size: 12px;
  }
</style>
